import { marketingPermissionSchema } from "@redotech/redo-marketing-common/marketing-permissions";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const marketingPermissionUserSchema = z.object({
  adminUserId: z.string(),
  email: z.email(),
  permissions: z.array(marketingPermissionSchema),
});

export type MarketingPermissionUser = z.infer<
  typeof marketingPermissionUserSchema
>;

export const getCurrentMarketingPermissions = unaryRpc({
  name: "getCurrentMarketingPermissions" as const,
  description:
    "Get the signed-in admin user's effective Marketing permissions.",
  input: z.object({}),
  output: z.object({ permissions: z.array(marketingPermissionSchema) }),
});

export const listMarketingPermissionUsers = unaryRpc({
  name: "listMarketingPermissionUsers" as const,
  description: "List admin users with direct Marketing permission grants.",
  input: z.object({}),
  output: z.object({ users: z.array(marketingPermissionUserSchema) }),
});

export const setMarketingPermissionUser = unaryRpc({
  name: "setMarketingPermissionUser" as const,
  description: "Create or replace an admin user's Marketing permissions.",
  input: z.object({
    email: z.email(),
    permissions: z.array(marketingPermissionSchema).min(1),
  }),
  output: marketingPermissionUserSchema,
});

export const removeMarketingPermissionUser = unaryRpc({
  name: "removeMarketingPermissionUser" as const,
  description:
    "Remove an admin user's Marketing grants while retaining their identity.",
  input: z.object({ email: z.email() }),
  output: z.object({ email: z.email(), removed: z.boolean() }),
});
